import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootReducer } from '../redux/rootReducer'
import { TOGGLE_CURSOR } from '../redux/slidesReducer'
import OutlinedButtonWithLoader from './OutlinedButtonWithLoader'
import IconButton from './IconButton'
import Pencil from '../icons/Pencil'
import Undo from '../icons/Undo'

type Props = {
  send: (action: string, payload: any) => void
}

const SlideTools = ({ send }: Props) => {
  const dispatch = useDispatch()
  const currentPosition = useSelector((state: RootReducer) => state.slidesReducer.slide.position)
  const cursorEnabled = useSelector((state: RootReducer) => state.slidesReducer.cursorEnabled)
  return (
    <div className="flex gap-4 mb-2 justify-between">
      <div className="w-[10rem]">
        <OutlinedButtonWithLoader
          label="Previous Slide"
          onClick={() => send('previous_slide', { current_position: currentPosition })}></OutlinedButtonWithLoader>
      </div>

      <div className="flex gap-2 text-slateGray">
        <IconButton icon={<Pencil />} active={cursorEnabled} onClick={() => dispatch(TOGGLE_CURSOR())}></IconButton>
        <IconButton icon={<Undo />} onClick={() => send('undo_line', {})}></IconButton>
      </div>

      <div className="w-[10rem]">
        <OutlinedButtonWithLoader
          label="Next slide"
          onClick={() => send('next_slide', { current_position: currentPosition })}></OutlinedButtonWithLoader>
      </div>
    </div>
  )
}

export default SlideTools
